module.exports = __webpack_public_path__ + "img/img_1.3a82198a.jpg";